/**
 * CQT Ammo marks.
 *
 * The logo is drawn for a dark ground (black plate, brass reticle, bone eagle).
 * There is no light-ground variant, so anywhere it appears it sits on the
 * `.plate` surface — which stays dark in both themes by design. Do not
 * `filter: invert()` it; that turns the brass green.
 */
import mark from "./assets/cqt-mark-96.png";
import full from "./assets/cqt-logo-320.png";

/** Small header mark. */
export function Mark({ className = "appbar__mark" }: { className?: string }) {
  return <img src={mark} alt="" className={className} width={32} height={32} />;
}

/** Large logo for the login / splash screen. */
export function Logo({ size = 160 }: { size?: number }) {
  return (
    <img
      src={full}
      alt="CQT Ammo"
      width={size}
      height={size}
      style={{ display: "block", width: size, height: size }}
    />
  );
}

/**
 * Header lockup: mark + wordmark + the current app's name.
 * `app` is the short app label, e.g. "CRM" or "ADMIN".
 */
export function BrandLockup({ app }: { app?: string }) {
  return (
    <div className="appbar__brand">
      <Mark />
      <span className="appbar__name">CQT&nbsp;Ammo</span>
      {app ? <span className="appbar__app">{app}</span> : null}
    </div>
  );
}
